import * as React from 'react';
import { colors } from '../../../index';

const IconCirclePlus = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.096 1.904A6.458 6.458 0 006.5 0a6.458 6.458 0 00-4.596 1.904A6.458 6.458 0 000 6.5c0 1.736.676 3.369 1.904 4.596A6.458 6.458 0 006.5 13a6.458 6.458 0 004.596-1.904A6.458 6.458 0 0013 6.5a6.458 6.458 0 00-1.904-4.596zM6.5 11.984A5.49 5.49 0 011.016 6.5 5.49 5.49 0 016.5 1.016 5.49 5.49 0 0111.984 6.5 5.49 5.49 0 016.5 11.984zm.508-5.992h2.285v1.015H7.008v2.285H5.992V7.007H3.707V5.992h2.285V3.707h1.016v2.285z",
    fill: "currentColor"
  }));
};

export default IconCirclePlus;